// extracted by mini-css-extract-plugin
export default {"root":"IconPickerTabContent_root__oesoD"};